import styled from '@emotion/styled';
import { Card } from '@fluentui/react-card'; // Different to carousel card hover
import { CardBody, CardFooter, CardHeader, blue, grey, tokens } from '@galaxy-react/core';

export const CardStyled = styled(Card)({
  backgroundColor: '#1C365F0A',
  boxShadow: 'none',
  borderRadius: tokens.borderRadiusXLarge,
  padding: '8px',
  minHeight: '320px',
});

export const CardHeaderStyled = styled(CardHeader, {
  shouldForwardProp: (prop) => prop !== 'hasReportDetails',
})<{ hasReportDetails?: boolean }>(({ hasReportDetails }) => ({
  rowGap: hasReportDetails ? tokens.spacingHorizontalM : '0',
  '& .fui-CardHeader__action': {
    gridRowStart: '1',
    height: '20px',
  },

  '& .fui-CardHeader__description': {
    display: 'grid',
    gridColumnEnd: 'span 3',
  },
}));

export const CardBodyStyled = styled(CardBody)({
  display: 'flex',
  borderBottom: `${tokens.strokeWidthThin} solid ${grey[200]}`,
  height: 'auto',
  flexDirection: 'column',
  padding: `0 ${tokens.spacingVerticalS} ${tokens.spacingHorizontalXS}`,
  '&.fui-CardPreview': {
    margin: '0',
    height: '100%',
    display: 'flex',
    gap: tokens.spacingHorizontalS,
    flexGrow: '1',
    paddingBottom: tokens.spacingHorizontalM,
    '>:not(.fui-CardPreview__logo)': {
      height: 'auto',
    },
  },
});

export const CardInfoStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: tokens.spacingVerticalXS,
});

export const CardBodyInfoStyled = styled(CardInfoStyled)({
  gap: tokens.spacingHorizontalS,
});

export const CardBodyFooterStyled = styled(CardFooter)({
  padding: `${tokens.spacingHorizontalNone} ${tokens.spacingVerticalS} ${tokens.spacingHorizontalXS}`,
  '&.fui-CardFooter': {
    flexDirection: 'column',
  },
});

export const CardHeaderContentStyled = styled('div')({
  display: 'grid',
  gridTemplateColumns: '20px 1fr',
  gap: tokens.spacingHorizontalS,
});

export const CardHeaderReportNameStyled = styled('span')({
  color: blue[700],
  fontWeight: tokens.fontWeightSemibold,
  lineHeight: tokens.lineHeightBase300,
});

export const CardHeaderDescriptionStyled = styled('span')({
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase200,
});

export const CardHeaderDescriptionWrapperStyled = styled('div')({
  // borderBottom: `${tokens.strokeWidthThin} solid ${grey[200]}`,
  paddingBottom: tokens.spacingHorizontalM,
  display: 'grid',
  gap: tokens.spacingHorizontalM,
});

export const CardPreviewReportDetailsStyled = styled('div')({
  fontSize: tokens.fontSizeBase200,
  fontWeight: tokens.fontWeightRegular,
  lineHeight: tokens.lineHeightBase200,
  color: grey[600],
});

export const CardPreviewOriginalNameStyled = styled('span')({
  '&::after': {
    content: '""',
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    marginLeft: tokens.spacingVerticalS,
    display: 'inline-block',
    verticalAlign: 'middle',
    backgroundColor: grey[600],
  },
});

export const CardPreviewViewsAndOriginalNameStyled = styled('div')({
  gap: tokens.spacingHorizontalS,
  display: 'flex',
});

export const BodyHeadingStyled = styled('div')({
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase200,
  fontWeight: tokens.fontWeightSemibold,
});

export const BodyDetailsStyled = styled('span')({
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase200,
});

export const FooterDetailsStyled = styled(BodyDetailsStyled)({
  whiteSpace: 'nowrap',
  display: 'block',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  cursor: 'pointer',
});

export const FooterPreviewStyled = styled('a')({
  display: 'grid',
  gridTemplateColumns: '16px 1fr',
  gap: tokens.spacingHorizontalS,
  alignItems: 'start',
  textDecoration: 'none',
  color: grey[800],
  cursor: 'pointer',
});
